export default __webpack_public_path__ + "static/media/amondo.50b115e8.jpg";